import { get } from "../common/remote/base_api";

export const GetCustomerdetailstrip = (id) => {
  return get(`admin/get-customer-trips/${id}/`);
};
